import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function PremiumPreviewBanner({ premiumPreview }) {
  const navigate = useNavigate();

  if (!premiumPreview?.active) return null;

  const expiresAt = new Date(premiumPreview.expiresAt);
  const now = new Date();
  const daysRemaining = Math.max(0, Math.ceil((expiresAt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)));
  const isUrgent = daysRemaining <= 2;

  return (
    <div
      className={`rounded-2xl p-4 ${
        isUrgent
          ? 'bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800'
          : 'bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800'
      }`}
    >
      <div className="flex items-start gap-3">
        <span className="text-2xl">{isUrgent ? '⏰' : '🎁'}</span>
        <div className="flex-1 min-w-0">
          {isUrgent ? (
            <>
              <p className="font-semibold text-amber-800 dark:text-amber-300 text-sm">
                Premium preview ends in {daysRemaining} day{daysRemaining !== 1 ? 's' : ''}!
              </p>
              <p className="text-xs text-amber-600 dark:text-amber-400 mt-0.5">
                You'll lose: unlimited habits, full calendar, streak freeze, advanced analytics...
              </p>
            </>
          ) : (
            <>
              <p className="font-semibold text-primary-800 dark:text-primary-300 text-sm">
                Premium analytics unlocked!
              </p>
              <p className="text-xs text-primary-600 dark:text-primary-400 mt-0.5">
                {daysRemaining} day{daysRemaining !== 1 ? 's' : ''} remaining in your preview
              </p>
            </>
          )}
          <button
            onClick={() => navigate('/premium?source=preview_expiring')}
            className={`mt-2 px-3 py-1.5 text-xs font-medium text-white rounded-lg transition-colors ${
              isUrgent
                ? 'bg-amber-600 hover:bg-amber-700'
                : 'bg-primary-600 hover:bg-primary-700'
            }`}
          >
            Keep Premium
          </button>
        </div>
      </div>
    </div>
  );
}
